<div class="row">
  <div class="col-md-12 pl-0">
    <div class="d-flex justify-content-between align-items-center m-Campaign-info">
      <div class="mb-3">
        <button mat-icon-button class="backArrow" (click)="closeEvent()">
          <mat-icon (click)="closeEvent()"> arrow_back </mat-icon>
        </button>
        <span class="capitalize ml-1"
          >Campaign Name : <strong>{{ selectedInfo.campaignName }}</strong></span
        >
      </div>

      <div class="posButtonWrap text-right pl-3 float-right">
        <button
          mat-stroked-button
          color="primary"
          class="ml-4 addBtn create-campaign"
          (click)="openEditCampaignSheet()"
        >
          <p class="mb-0">+ Add Contact</p>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="row w-100">
  <div class="col-md-3 col-sm-4 col-6">
    <mat-form-field class="w-100">
      <mat-select (selectionChange)="emailStatus($event)" [(value)]="selectedEmailStatus" placeholder="Email Status">
        <mat-option [value]="'all'">All</mat-option>
        <mat-option [value]="'read'">Read</mat-option>
        <mat-option [value]="'unRead'">Unread</mat-option>
        <mat-option [value]="'Not Sent'">Not sent</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-md-3 col-sm-4 col-6">
    <mat-form-field class="w-100">
      <mat-label> Search </mat-label>
      <input
        matInput
        [(ngModel)]="searchValue"
        autocomplete="off"
        placeholder="Search Name"
        [ngModel]="model"
        (ngModelChange)="changed($event)"
      />
    </mat-form-field>
  </div>
</div>

<div class="row w-100 mt-2" *ngIf="!isLoadingCampaignStatistics">
  <div class="col-md-4 mb-3">
    <strong>Campaign Name: </strong>
    <span class="ms-1">{{ selectedInfo.campaignName }} </span>
  </div>
  <div class="col-md-4 mb-3">
    <strong>Campaign Type: </strong>
    <span class="ms-1">{{ getCampaignTypeKey(selectedInfo.type) }}</span>
  </div>

  <div class="col-md-4 mb-3">
    <strong>Campaign Launched: </strong>
    <span class="ms-1">{{ selectedInfo?.launchDate | simpleDate }}</span>
  </div>

  <div class="col-md-4 mb-3">
    <strong>Automated / Frequency:</strong>
    <span class="ms-1"> {{ frequency ? 'Yes / ' + (frequency | titlecase) : 'No' }} </span>
  </div>

  <div class="col-md-4 mb-3">
    <strong>Last Sent:</strong>
    <span class="ms-1">
      {{ selectedInfo?.updatedDate | date }}
    </span>
  </div>

  <div class="col-md-4 mb-3" *ngIf="frequency">
    <strong>Total Runs:</strong>
    <span class="ms-1">
      {{ totalRun }}
    </span>
  </div>

  <div class="col-md-4 mb-3">
    <strong class="engagement-label">
      <span>Total Engagement</span>
      <mat-icon
        class="help-icon"
        [matTooltip]="'Shows the percentage of recipients who opened one or more campaign emails'"
        matTooltipPosition="right"
        matTooltipClass="line-break"
      >
        help_outline
      </mat-icon>
      <span>:</span>
    </strong>
    <span class="ms-1">
      {{
        selectedInfo?.totalReadCount
          ? (((selectedInfo?.totalReadCount || 0) / selectedInfo.candidateCount) * 100 | number: '1.2-2') + '%'
          : 0
      }}
    </span>
  </div>
</div>

<div class="mb-3 row w-100">
  <div class="col-lg-12 mt-2">
    <div class="table_base">
      <div class="table-responsive table_wrap">
        <table mat-table [dataSource]="tableDataSourceInfo" class="mat-elevation-z2 w-100">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                color="primary"
                (change)="$event ? masterToggle($event) : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                color="primary"
                (click)="$event.stopPropagation()"
                (change)="$event ? toggleSelect(row, $event.checked) : null"
                [checked]="selection.isSelected(row)"
                [disabled]="row.unSubscribeAll"
              >
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element">{{ element.position }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">
              <span class="truncated mt-0"> {{ element.fullName }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef class="align-center">Email</th>
            <td mat-cell *matCellDef="let element" class="align-center">
              {{ element.email }}
            </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef class="align-center">Phone Number</th>
            <td mat-cell *matCellDef="let element" class="align-center">{{ element.phone }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="align-center">Email Status</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="align-center"
              [matTooltip]="element.openStatus === 'Not Sent' ? element.errorMessage : null"
            >
              {{ element.openStatus == 'unRead' ? 'Unread' : element.openStatus }}
            </td>
          </ng-container>

          <ng-container matColumnDef="emailCount">
            <th mat-header-cell *matHeaderCellDef class="align-center">Email Count</th>
            <td mat-cell *matCellDef="let element" class="align-center">{{ element.emailSendCount }}</td>
          </ng-container>

          <ng-container matColumnDef="lastopened">
            <th mat-header-cell *matHeaderCellDef>Last Opened</th>
            <td mat-cell *matCellDef="let element">{{ element.lastOpened | simpleDate }}</td>
          </ng-container>

          <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef>Created On</th>
            <td mat-cell *matCellDef="let element">
              {{ element.status != 'idle' ? (element.createdDate | simpleDate) : '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>Address</th>
            <td mat-cell *matCellDef="let element">
              <span [propertyAddress]="element.propertyAddress">{{ element.propertyAddress }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="substatus">
            <th mat-header-cell *matHeaderCellDef>Email Subscription Status</th>
            <td mat-cell *matCellDef="let element">
              {{ element.unSubscribeAll ? 'Unsubscribed' : 'Active' }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
          <tr mat-row (click)="openStatusSheet(row)" *matRowDef="let row; columns: tableColumnList"></tr>
        </table>
        <app-status-campaign-sheet
          [campaignType]="'generalCampaign'"
          (loadStatistics)="getCampaignInfo()"
          [selectedStatus]="statusId"
          *ngIf="campaignState.openCampaignStatusSheet$ | async"
        >
        </app-status-campaign-sheet>
        <div
          class="flex_center w-100"
          *ngIf="!tableDataSourceInfo || (tableDataSourceInfo.data.length == 0 && !isLoadingCampaignStatistics)"
        >
          <div class="notFound text-center noData">
            <div>
              <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
              <h4>No search result found</h4>
            </div>
          </div>
        </div>
        <div class="flex_center w-100" *ngIf="isLoadingCampaignStatistics">
          <div class="notFound text-center noData">
            <mat-spinner [diameter]="30" class="mr-3"> </mat-spinner>
            Please wait while we load
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center m-d-block">
        <button
          *ngIf="selectedRecordIdList.length > 0"
          mat-stroked-button
          color="primary"
          class="ml-4 addBtn create-campaign"
          (click)="openCampaignSheet()"
        >
          <p class="mb-0">Add To New Campaign</p>
        </button>
        <mat-paginator
          [length]="totalRecords"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="[10, 20]"
          (page)="pageChange($event)"
          showFirstLastButtons
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
<!-- <div class="row">
  <div class="col-sm-12">
    <div class="posButtonWrap text-right pl-3 float-right">
      <button mat-flat-button color="primary" class="ml-2 addBtn" (click)="openCampaignSheet()">
        <p class="mb-0">Create Campaign</p>
      </button>
    </div>
  </div>
</div> -->
